import React from 'react';
import Link from 'next/link';
import { Card, CardContent } from '@tmap/mmm-style-guide/src/Card';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { LocationOn } from '@tmap/mmm-style-guide/src/Icon';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

const Header = styled('div')(({ theme }) => ({
  fontSize: 14,
  textAlign: 'center',
  color: theme.palette.primary.veryDark,
}));

const LocationIcon = styled(LocationOn)(({ theme }) => ({
  color: theme.palette.grey[600],
}));

const OfferLink = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.primary.veryDark,
  color: theme.palette.primary.contrastText,
  padding: '24px 12px',
  width: '100%',
  margin: '16px 0',
}));

function SimilarOffersCard({ offers, headerText }) {
  return (
    <Card elevation={1} sx={{ height: '100%', paddingBottom: '24px', borderRadius: '8px' }}>
      <CardContent sx={{ height: '100%' }}>
        <Header>
          <strong>{headerText || 'Similar Programs'}</strong>
          <br />
          you may be interested in
        </Header>
        {offers.map((offer) => (
          <Link href={`/get-paid/${encodeURIComponent(offer.slug.current)}`}>
            <OfferLink>
              <Grid
                item
                container
                direction='row'
                justifyContent='flex-start'
                alignItems='center'
              >
                <Grid item sx={{ display: 'flex', marginRight: '2px' }}>
                  <LocationIcon fontSize='small' />
                </Grid>
                <Grid item sx={{ display: 'flex', flexGrow: 1 }}>
                  {offer.locationText}
                </Grid>
                <Grid item sx={{ display: 'flex', color: 'secondary' }}>
                  <Typography color='secondary'>{offer.totalValue ? `$${new Intl.NumberFormat().format(offer.totalValue)}` : ''}</Typography>
                </Grid>
              </Grid>
            </OfferLink>
          </Link>
        ))}
      </CardContent>
    </Card>
  );
}

export default SimilarOffersCard;
